import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type AddDetachCarrierModalProps = {
  itemId: string;
};

function makeDetachCarrierControl() {
  const tags = ["Yes"];
  return [
    makeSelectControl(
      "Detach?",
      "detach",
      tags,
      "Please confirm that you are detaching carrier.",
    ),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function AddDetachCarrierModal({ itemId }: AddDetachCarrierModalProps) {
  const tagFormControl = React.useMemo(() => makeDetachCarrierControl(), []);
  const addTagToast = useCustomToast(() => (
    <Alert status="success">Carrier detached!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_DETACH_CARRIER,
    addTagToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = "Detaching carrier";
      (data.comments ? (data.comments as string) + ", " : "") +
        "detaching carrier";
      addStep(comments);
    },
    [addStep],
  );

  return (
    <ButtonModal label="Detach Carrier" title="Detach Carrier" size="sm">
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
